<template>
  <div>
    <div class="Information">
      <div class="InformationHeader">
        <!-- 头像暂无 -->
        <!-- <img src="https://dummyimage.com/88x66/99f/fff" alt=""> -->
        <div class="custom-info">
            <span class="custom-name-first">{{nameFirst}}</span>
        </div>
        <div class="infoRight">
          <div class="infoName">{{$store.state.userInfo.userName}}</div>
          <div class="infoCname">{{$store.state.userInfo.compCnName}}</div>
          <div class="infoCname" v-if="$store.state.userInfo.mobile==null || $store.state.userInfo.mobile.trim()=='' ">手机号：--</div>
          <div class="infoCname" v-if="$store.state.userInfo.mobile && $store.state.userInfo.mobile.trim()">手机号：{{$store.state.userInfo.mobile}}</div>
        </div>
      </div>
      <div class="operate">
        <span class="operateLabe">快捷操作</span>
        <div class="operateList">
          <a :href="`${onlineUrl}/supplier-profile`">
          <el-tag>企业档案</el-tag>
          </a>
          <router-link :to="{ name: 'product-case-list' }">
            <el-tag>管理零件</el-tag>
          </router-link>
          <a :href="`${onlineUrl}/get-supplier-user-preference`">
            <el-tag class="middleTag">偏好设置</el-tag>
          </a>
          <a :href="`${onlineUrl}/purchase-order/supplier/administration/account-info`">
            <el-tag>账号安全</el-tag>
          </a>
          <a v-if="$store.state.userInfo.clientSource == 10" :href="$store.state.userInfo.traderThemeInfo?.themeInfo?.siteUrl">
            <el-tag>宜昌装备制造平台</el-tag>
          </a>
        </div>
      </div>
    </div>


    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="402px"
      :before-close="handleClose"
      custom-class="qcDialogClass"
      :close-on-click-modal="false">
      <div class="dialog-body">
        <div>
          <p> <i class="iconfont icon-error-circle-filled" style="color: #FF7F2A;margin-right:8px"></i>您工厂的资质认证：</p>
          <p style="margin-left:22px;line-height:18px;margin-bottom:4px;" v-for="(item,index) in qcList" :key="index">[{{ item.certValue }}]已于[{{handleFormatDate(item.validity)}}] 过期！</p>
          
        </div>
        <ul >
          此状态将导致：
          <li>部分询盘报价受限</li>
          <li>AI供应商推荐受限</li>
          <li>档案展示曝光受限</li>
        </ul>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="goProfile">立即更新资质认证</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { onlineUrl } from '@/utils/config';
import { findQC } from '@/utils/api/dashboard';
import moment from "moment";
export default {
  data(){
    return{
      nameFirst:'',
      onlineUrl,
      qcList:[],
      dialogVisible:false
    }
  },
  methods:{
    // 查询供应商过期资质认证列表
    async getQcFN(){
      try {
        const res = await findQC()
        if(res.rspResult.bizCode==200){
          this.qcList = res.rspListData.list
          if(this.qcList.length){
            this.dialogVisible = true
          }
        }else{
          this.$message.error(res.rspResult.message)
        }
      } catch (error) {
        console.log('查询供应商过期资质认证~~',error)
      }
    },
    handleClose(){
      this.dialogVisible =false
    },
    handleFormatDate(value) {
      if(value) {
        return moment(value).format('YYYY-MM-DD');
      }
      return '--'
    },
    goProfile(){
      this.dialogVisible = false
      let url = this.onlineUrl+'/supplier-profile?tab=cert'
      window.open(url,'_blank')
    }
  },
  mounted(){
    this.nameFirst=this.$store.state.userInfo.userName.slice(0,1)
    this.getQcFN()
  },
}
</script>
<style  lang="scss" scoped>
.Information{
  margin-bottom: 12px;
  background: #fff;
  padding: 20px;
  box-shadow: 0 1px 6px 0 #001e3b12;
  .InformationHeader{
    display: flex;
    img{
      width: 48px;
      height: 48px;
      border-radius: 50%;
    }
    .infoRight{
      .infoName{
        font-family: SourceHanSansCN-Bold;
        font-weight: 700;
        font-size: 16px;
        color: #16181A;
      }
      .infoCname{
        font-family: SourceHanSansCN-Regular;
        font-weight: 400;
        font-size: 14px;
        color: #16181A;
        line-height:28px;
      }
    }
  }
  .operate{
    margin-top: 10px;
    display: flex;
    font-family: SourceHanSansCN-Regular;
    .operateLabe{
      margin-top: 10px;
      font-weight: 400;
      font-size: 14px;
      color: #4F5D78;
      margin-right: 18px;
      width: max-content;
      min-width: max-content;
    }
    .el-tag{
      margin-top: 10px;
      margin-right: 12px;
    }
    .middleTag{
      // margin: 0 12px;
    }

  }
}
.custom-info {
  // margin-left: 20px;
  padding-right: 18px;
  height: max-content;
  display: flex;
  align-items: center;
  // cursor: pointer;
  .custom-name-first {
    width: 48px;
    height: 48px;
    background: #318CED;
    line-height: 48px;
    border-radius: 50%;
    font-family: Arial;
    font-weight: 700;
    font-size: 20px;
    color: #fff;
    text-align: center;
    letter-spacing: 0;
    user-select: none;
    margin-right: 8px;
    .iconfont{
        font-size: 16px;
    }
  }
}

:deep(.qcDialogClass){
  font-family: SourceHanSansCN-Regular ;
  border-radius: 8px;
  .el-dialog__header{
    font-weight: 600;
    color: #16181A;
    padding: 24px 24px 18px;
  }
  .el-dialog__body{
    padding: 0 25px;
    color: #4f5d78;
    max-height: 460px;
    overflow: auto;
    ul{
      list-style-type: disc;
      margin-top:16px;
      line-height: 24px;
      margin-left:22px;
      li{
        margin-left: 22px;
      }
    }
  }
  .el-dialog__footer{
    text-align: center;
    padding: 24px;
    .el-button--small{
      font-size: 14px;
    }
  }
}
</style>
